import { Moon01, Sun } from "@untitledui/icons"
import type { ReactNode } from "react"
import { useState } from "react"

interface UuiKitDemosLayoutProps {
  children: ReactNode
}

function DebugBar() {
  const [isDarkMode, setIsDarkMode] = useState(
    () =>
      typeof document !== "undefined" &&
      document.documentElement.classList.contains("dark-mode"),
  )

  const toggleDarkMode = () => {
    const newValue = !isDarkMode
    setIsDarkMode(newValue)
    localStorage.setItem("demo-dark-mode", String(newValue))

    if (newValue) {
      document.documentElement.classList.add("dark-mode")
    } else {
      document.documentElement.classList.remove("dark-mode")
    }
  }

  return (
    <div className="bg-primary ring-secondary fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-full px-4 py-2 shadow-lg ring-1">
      <span className="text-tertiary text-sm font-medium">Theme</span>
      <button
        onClick={toggleDarkMode}
        className="bg-secondary text-primary hover:bg-tertiary flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-medium transition-colors"
      >
        {isDarkMode ? <Moon01 size={16} /> : <Sun size={16} />}
        {isDarkMode ? "Dark" : "Light"}
      </button>
    </div>
  )
}

export default function UuiKitDemosLayout({
  children,
}: UuiKitDemosLayoutProps) {
  return (
    <>
      {children}
      <DebugBar />
    </>
  )
}
